// extracted by mini-css-extract-plugin
export default {"mainBlock":"Footer_mainBlock__6pJKY","hoverText":"Footer_hoverText__Tkem8"};